import { applyOrderTypesWorkingStatusThunk } from '../../redux/thunk/platformWorkingStatus'
import { logger } from '../../logger/logger'

export const processShopMessageThunk = (message) => (dispatch) => {
	switch (message?.type) {
		case 'shop.PLATFORM_WORKING_STATUS_CHANGED':
			dispatch(applyOrderTypesWorkingStatusThunk(message.data))
			break
		default:
			logger.error('Unknown shop message type: ', JSON.stringify(message))
			break
	}
}
